// src/config/index.ts
interface Config {
    apiEndpoint: string;
    apiPrefix: string;
    apiImport: string;
    frontEndpoint: string;
    version: string;
    hubSpotTrackingCode: string;
  }

  function resolvePlaceholder(value: string | undefined, fallback: string): string {
    if (!value || value.startsWith('__')) {
      return fallback;
    }
    return value;
  }

  function getConfig(): Config {
    const runtimeConfig: Partial<EnvConfig> = window.ENV_CONFIG || {};

    return {
      apiEndpoint: resolvePlaceholder(
        runtimeConfig.apiEndpoint,
        process.env.VUE_APP_API_ENDPOINT || 'https://api.staging.inn.cash/',
      ),
      apiPrefix: resolvePlaceholder(
        runtimeConfig.apiPrefix,
        process.env.VUE_APP_API_PREFIX || '',
      ),
      apiImport: resolvePlaceholder(
        runtimeConfig.apiImport,
        process.env.VUE_APP_API_IMPORT || '',
      ),
      frontEndpoint: resolvePlaceholder(
        runtimeConfig.frontEndpoint,
        process.env.VUE_APP_ENDPOINT || 'https://staging.inn.cash/',
      ),
      version: resolvePlaceholder(
        runtimeConfig.version,
        process.env.VUE_APP_INNCASH_VERSION || '1.5.0',
      ),

      hubSpotTrackingCode: resolvePlaceholder(
        runtimeConfig.hubSpotTrackingCode,
        process.env.VUE_APP_HUBSPOT_TRACKING_CODE || null,
      ),
    };
  }

  const config = getConfig();

  export default config;
